import { useMemo, useState } from "react"
import { useParams } from "react-router-dom"

import {
  formatDeviceAlerts,
  getAlertAmounts,
  getFilteredSortedAlerts,
  sortAndGroupAlerts,
} from "helpers/formatters/alertSettingsFormatters"
import useAlertSettings from "helpers/hooks/useAlertSettings"
import useAlertSettingsWStates from "helpers/hooks/useAlertSettingsStates"
import useDevices from "helpers/hooks/useDevices"
import type { AlertsFilterOptions } from "types/alerts.types"
import Spinner from "widgets/common/Spinner"
import AlertsFilter from "widgets/alerts/AlertsFilter"
import AccordionsSection from "widgets/alerts/AccordionsSection"
import { SectionContainer } from "widgets/styled/containers"

const DeviceAlertsContent = () => {
  const { id } = useParams()
  const { getDeviceAlertSettingsWStatesByEntityId, isLoading } = useAlertSettingsWStates()
  const { orgDevicesAlertSettingsById } = useAlertSettings()
  const { devsWRelsById } = useDevices()
  const [filters, setFilters] = useState<AlertsFilterOptions | null>(null)

  const deviceSettingsStates = useMemo(
    () => getDeviceAlertSettingsWStatesByEntityId(Number(id)),
    [getDeviceAlertSettingsWStatesByEntityId, id],
  )

  const formattedDeviceAlerts = useMemo(
    () =>
      formatDeviceAlerts(
        deviceSettingsStates,
        orgDevicesAlertSettingsById,
        devsWRelsById,
      ),
    [deviceSettingsStates, orgDevicesAlertSettingsById, devsWRelsById],
  )
  const sortedAndGroupedAlerts = useMemo(
    () => sortAndGroupAlerts(formattedDeviceAlerts),
    [formattedDeviceAlerts],
  )
  const deviceAlertsAmount = useMemo(
    () => getAlertAmounts(sortedAndGroupedAlerts),
    [sortedAndGroupedAlerts],
  )
  const deviceAlertsSortedByState = useMemo(
    () => getFilteredSortedAlerts(sortedAndGroupedAlerts, filters),
    [sortedAndGroupedAlerts, filters],
  )

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <SectionContainer disableGutters maxWidth="xl">
          <AlertsFilter
            alertsAmount={deviceAlertsAmount}
            filters={filters}
            setFilters={setFilters}
            withDisabled
          />
          <AccordionsSection
            alerts={deviceAlertsSortedByState}
            filters={filters}
            entityPage
          />
        </SectionContainer>
      )}
    </>
  )
}

export default DeviceAlertsContent
